import { styled } from "@/root/stitches.config";
import DividerImage from "@/assets/icons/divider.svg";

const BaseDivider = styled("img", {
    display: "block",
    width: "fit-content",
    height: 10,
    objectFit: "cover",
    objectPosition: "center",
});

export default function Divider({ color = "light", ...props }) {
    return (
        <BaseDivider
            src={DividerImage}
            alt="Divider"
            {...props}
        />
    );
}